import Download from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import { useMemo, useState } from "react";

import { mergeDefaultAndOmnisearch } from "../Manifests/mergeDefaultAndOmnisearch";
import { BulkDownloadSubmissionsModal } from "./BulkDownloadSubmissionsModal";

type Props = {
  tenantId: string | undefined;
  defaultSearch: string;
  getOmnisearch: () => string;
};

export function BulkDownloadSubmissionsButton({ tenantId, defaultSearch, getOmnisearch }: Props) {
  const [open, setOpen] = useState(false);
  const search = useMemo(
    () => (open ? mergeDefaultAndOmnisearch(defaultSearch, getOmnisearch()) : ""),
    [open, defaultSearch, getOmnisearch]
  );

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Download />}
        onClick={() => setOpen(true)}
        sx={{ whiteSpace: "nowrap" }}
      >
        Download PDFs
      </Button>
      {open && (
        <BulkDownloadSubmissionsModal
          open={open}
          onClose={() => setOpen(false)}
          search={search}
          tenantId={tenantId}
        />
      )}
    </>
  );
}
